// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { GLYPH_STROKE, type GlyphLeads } from './glyph';

/**
 * The two short conductor leads that carry a symbol to the edge of its grid,
 * so a device drawn as its symbol meets the run entering and leaving it. On
 * the 24-grid every symbol sits on the vertical centreline, so a lead is a
 * vertical line from the edge to where the shape starts.
 */
export const Leads = ({
  top,
  bottom,
  leads,
}: {
  top: number;
  bottom: number;
  /** Which leads to draw; a chain's first or last device has nothing to meet. */
  leads?: GlyphLeads;
}) => (
  <>
    {leads?.top !== false && (
      <line x1="12" y1="0" x2="12" y2={top} stroke="currentColor" strokeWidth={GLYPH_STROKE} />
    )}
    {leads?.bottom !== false && (
      <line x1="12" y1={bottom} x2="12" y2="24" stroke="currentColor" strokeWidth={GLYPH_STROKE} />
    )}
  </>
);
